import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { AppStoreModel } from '../store/app.store.model';
import { AppStoreActions } from '../store/app.store.actions';
import { LocalStorageKeysEnum } from '../utils/enums';
import { LocalStorageService } from './infrastructure/local-storage.service';
import { ProgramaComparador, UniversidadComparador } from '../types/general.type';
import { APP_STATE_TOKEN } from '../store/app.store.state';

@Injectable({
  providedIn: 'root'
})
export class ComparadorService {

  constructor(
    private store: Store,
    private localStorage: LocalStorageService
  ) { }

  existeUniversidadEnComparador = (id: number) => {
    const { globalConfig } = this.store.selectSnapshot(APP_STATE_TOKEN);
    return globalConfig.comparador.universidades.filter(x => x.id == id).length > 0;
  }

  agregarUniversidad = (item: UniversidadComparador) => {
    this.store.dispatch(new AppStoreActions.Config.AgregarUniversidadComparador([item])).subscribe((s) => {
      this.setUniversidadesLocalStorage(s.appState);
    });
  }

  quitarUniversidad = (id: number) => {
    this.store.dispatch(new AppStoreActions.Config.QuitarUniversidadComparador({ id })).subscribe((s) => {
      this.setUniversidadesLocalStorage(s.appState);
    });
  }

  agregarPrograma = (item: ProgramaComparador) => {
    this.store.dispatch(new AppStoreActions.Config.AgregarProgramaComparador([item])).subscribe((s) => {
      this.setProgramasLocalStorage(s.appState);
    });
  }

  quitarPrograma = (id: number, idUniversidad: number, idModalidadEstudio: number) => {
    this.store.dispatch(new AppStoreActions.Config.QuitarProgramaComparador({ id, idUniversidad, idModalidadEstudio })).subscribe((s) => {
      this.setProgramasLocalStorage(s.appState);
    });
  }

  // ui

  openComparador = (open: boolean) => {
    this.store.dispatch(new AppStoreActions.Ui.OpenComparadorInferior({
      open
    }));
  }

  colapsarComparador = (colapsar: boolean) => {
    this.store.dispatch(new AppStoreActions.Ui.ColapsarComparadorInferior({ collapse: colapsar }));
  }

  setUniversidadesLocalStorage = (appState: AppStoreModel) => {
    this.localStorage.set(
      LocalStorageKeysEnum.UNIVERSIDADES,
      appState.globalConfig.comparador.universidades
    );
  }


  setProgramasLocalStorage = (appState: AppStoreModel) => {
    this.localStorage.set(
      LocalStorageKeysEnum.CARRERAS,
      appState.globalConfig.comparador.programas
    );
  }


  loadUniversidadesFromLocalStorage = () => {
    const data = this.localStorage.get<any[]>(LocalStorageKeysEnum.UNIVERSIDADES);
    this.store.dispatch(new AppStoreActions.Config.AgregarUniversidadComparador(data ? data : []));
  }

  loadCarrerasFromLocalStorage = () => {
    const data = this.localStorage.get<any[]>(LocalStorageKeysEnum.CARRERAS);
    this.store.dispatch(new AppStoreActions.Config.AgregarProgramaComparador(data ? data : []));
  }
}
